import React, { FC } from 'react'
import { MovableModalContainer } from 'components/MovableModal'
import { useSelector } from 'react-redux'
import { selectShowTranscribe } from 'selectors/mainView'
import Transcribe from 'components/Transcribe/Transcribe'

export const TranscribeContainer: FC = () => {
  const visible = useSelector(selectShowTranscribe)
  return (
    <MovableModalContainer
      visible={visible}
      restorePosition={false}
      width={400}
      height={230}
      withBackground
      pointerEvents={false}
      windowId="TranscribeContainer"
    >
      <Transcribe />
    </MovableModalContainer>
  )
}
